import styled from 'styled-components';

export const ModalWrapper = styled.div`
  display: ${props => props.show ? 'flex' : 'none'};
  align-items: flex-start;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(51, 51, 51, 0.5);
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: white;
  border: 1px solid #ddd;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 20px;
  width: 70%;
  max-width: 600px;
  text-align: flex-start;
  z-index: 1001;
  border-top: none; 

  p {
    color: #333;
  }

  span {
    color: #aaa;
    float: right;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: #555;
    }
  }
`;

export const CloseButton = styled.span`
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;

  &:hover {
    color: black;
    cursor: pointer;
  }
`;
